import React, { Component } from 'react';
import { db } from '../firebase';
import { Col, Button, Form, FormGroup, Label, Input} from 'reactstrap';
import PropTypes from 'prop-types';
import { Link, withRouter,} from 'react-router-dom';
import * as routes from '../Constants/routes';

const byPropKey = (propertyName, value) => () => ({
  [propertyName]: value,
});

const loginStyle = {
//  marginTop: 20,
  backgroundColor: "white",
  paddingBottom: 20
};

const INITIAL_STATE = {
  Comment: '',
  error: null,
};

const PostComment = (props, { authUserId, authUser, userName, inGameName }) =>
<React.Fragment>
    { authUser
        ? <PostCommentAuth authUserId={props.authUserId} comments={props.comments} articleId={props.articleId} userName={props.userName} inGameName={props.inGameName}  />
        : <PostCommentNonAuth />
    }
</React.Fragment>

PostComment.contextTypes = {
  authUser: PropTypes.object
};


class PostCommentAuth extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = { ...INITIAL_STATE };

  }

  onSubmit = (event) => {
    const { Comment} = this.state;
    var commentList = (this.props.comments ? this.props.comments : []);
    var thethis = this;
    var commentDate = new Date();

    var commentObj = {userId: thethis.props.authUserId, userName: thethis.props.userName, inGameName: thethis.props.inGameName, commentDate: commentDate, comment: Comment }
    commentList.push(commentObj);
    db.postComment(thethis.props.articleId,commentList)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });
/*
    auth.doPasswordUpdate(passwordOne)
      .then(() => {
        this.setState(() => ({ ...INITIAL_STATE }));
      })
      .catch(error => {
        this.setState(byPropKey('error', error));
      });
*/
//    event.preventDefault();
  }

  render() {
    const {
      Comment,
      error,
    } = this.state;

    var buttonStyle={
      marginTop: 10
    }

    return (

      <Form style={loginStyle} onSubmit={this.onSubmit}>
      <hr />
      <FormGroup row>
        <Label  for="Comment" sm={2}>Add Comment</Label>
        <Col sm={10}>
        <Input id="Comment"
          value={Comment}
          onChange={event => this.setState(byPropKey('Comment', event.target.value))}
          type="textarea"
        />
        </Col>
        </FormGroup>
        <Button style={buttonStyle} type="submit">
          Submit
        </Button>
        { error && <p>{error.message}</p> }
      </Form>
    );
  }
}


const PostCommentNonAuth = () =>
    <div style={loginStyle} align="center">
      Please <Link to={routes.LOGIN}>Log In</Link> to post comments.
    </div>


export default PostComment;



// WEBPACK FOOTER //
// ./src/Articles/PostComment.js